import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import * as TakeOutOrderStore from './TakeOutOrderStore';
import { Command } from 'pos/common';
import { Permission } from 'core/api';

declare global {
	interface CommandType {
		deliverTakeOutOrder: (orderId: number, deliveryPerson?: string) => Promise<Result>
	}
}

Command.register('deliverTakeOutOrder', Preconditions.and(Preconditions.ensure(Permission.SalesOrder_Deliver), Preconditions.ensureIsNotLite), async (orderId: number, deliveryPerson?: string): Promise<Result> => {

	const result = await Command.execute('changeTakeOutOrderDeliveryPerson', orderId, deliveryPerson, 'IGNORE_IF_NO_DELIVERY_PERSONS');
	if (!result.ok)
		return result;

	await TakeOutOrderStore.deliver(orderId);

	return Result.ok();

});
